document.addEventListener("DOMContentLoaded", function () {
  toggleBlogView();
  adjustOverlayTop();
  restoreCheckboxStates();
  setupSortDropdowns();
  setupSortOptions();
});

window.addEventListener("resize", toggleBlogView);

function toggleBlogView() {
  const desktopBlog = document.getElementById("desktop-blog");
  const mobileBlog = document.getElementById("mobile-blog");

  if (window.innerWidth > 768) {
    desktopBlog.style.display = "block";
    mobileBlog.style.display = "none";
  } else {
    desktopBlog.style.display = "none";
    mobileBlog.style.display = "block";
  }
}

function adjustOverlayTop() {
  const overlay = document.querySelector(".overlay");
  const drop = document.querySelector(".show_results");
  const filterover = drop.getBoundingClientRect();
  overlay.style.top = filterover.y + 88.2 + "px";
  overlay.style.height = document.body.clientHeight - (filterover.y + 88.2) + "px";
}

function listFunction() {
  const dropdownDesktop = document.getElementById("DropdownDiv-desktop");
  const overlay = document.querySelector(".overlay");

  dropdownDesktop.classList.toggle("show");
  const isDropdownVisible = dropdownDesktop.classList.contains("show");
  overlay.style.display = isDropdownVisible ? "block" : "none";
  document.body.classList.toggle("no-scroll-blog", isDropdownVisible);

  adjustOverlayTop();
}

function mobileListFunction() {
  const dropdownMobile = document.getElementById("DropdownDiv-mobile");
  const iconClose = document.querySelector(".icon-close_mobile");
  const elementsToHide = [
    document.querySelector(".breadcrum-custom-page-width"),
    document.querySelector(".main-blog-head_mobile"),
    document.querySelector(".featured-article_mobile"),
    document.querySelector(".blog-articles_mobile"),
    document.querySelector(".footer"),
    document.querySelector(".sort_blog_mobile"),
  ];

  dropdownMobile.classList.toggle("show");
  const isDropdownVisible = dropdownMobile.classList.contains("show");
  iconClose.style.display = isDropdownVisible ? "block" : "none";

  elementsToHide.forEach((element) => {
    if (element) {
      element.style.display = isDropdownVisible ? "none" : "block";
    }
  });

  if (isDropdownVisible) {
    document.body.style.display = "block"; // Remove display: grid
  } else {
    document.body.style.display = ""; // Reset to default
  }
}

function closeTestBlog() {
  const dropdownMobile = document.getElementById("DropdownDiv-mobile");
  const iconClose = document.querySelector(".icon-close_mobile");
  const elementsToShow = [
    document.querySelector(".breadcrum-custom-page-width"),
    document.querySelector(".main-blog-head_mobile"),
    document.querySelector(".featured-article_mobile"),
    document.querySelector(".blog-articles_mobile"),
    document.querySelector(".footer"),
    document.querySelector(".sort_blog_mobile"),
  ];

  dropdownMobile.classList.remove("show");
  iconClose.style.display = "none";
  document.body.classList.remove("no-scroll-blog");

  elementsToShow.forEach((element) => {
    if (element) {
      element.style.display = "block";
    }
  });

  document.body.style.display = ""; // Reset to default
}

window.addEventListener("click", function (event) {
  const dropdownButton = document.querySelector(".dropbtn");
  const dropdownContent = document.getElementById("DropdownDiv-desktop");
  const overlay = document.querySelector(".overlay");

  if (!dropdownButton.contains(event.target) && !dropdownContent.contains(event.target)) {
    dropdownContent.classList.remove("show");
    overlay.style.display = "none";
    document.body.classList.remove("no-scroll-blog");
  }
});

(function () {
  const filterTags = new Set(JSON.parse(localStorage.getItem("selectedTags")) || []);
  const filterCheckBoxes = document.querySelectorAll('.filter_tags input[type="checkbox"]');

  filterCheckBoxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        filterTags.add(checkbox.value);
      } else {
        filterTags.delete(checkbox.value);
      }
      localStorage.setItem("selectedTags", JSON.stringify(Array.from(filterTags)));
    });
  });

  window.showResults = function () {
    const filterTags = JSON.parse(localStorage.getItem("selectedTags")) || [];
    if (filterTags.length > 0) {
      const filterTag = filterTags.join("+");
      window.location.href = `/blogs/news/tagged/${filterTag}`;
    }
  };
})();

function resetFilter() {
  const checkboxes = document.querySelectorAll('.filter_tags input[type="checkbox"]');

  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  localStorage.removeItem("selectedTags");

  window.location.href = "/blogs/news";
  document.getElementById("DropdownDiv-desktop").classList.remove("show");
  document.querySelector(".overlay").style.display = "none";
  document.body.classList.remove("no-scroll-blog");
}

function restoreCheckboxStates() {
  const checkboxes = document.querySelectorAll('.filter_tags input[type="checkbox"]');
  const selectedTags = JSON.parse(localStorage.getItem("selectedTags")) || [];

  checkboxes.forEach((checkbox) => {
    checkbox.checked = selectedTags.includes(checkbox.value);
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        localStorage.setItem(checkbox.id, true);
      } else {
        localStorage.removeItem(checkbox.id);
      }
    });
  });
}

function setupSortDropdowns() {
  const sortBtns = document.querySelectorAll(".sortbtn");
  const sortDropdownDesktop = document.getElementById("SortDropdown-desktop");
  const sortDropdownMobile = document.getElementById("SortDropdown-mobile");

  sortBtns.forEach((sortBtn) => {
    sortBtn.addEventListener("click", function () {
      if (sortBtn.closest("#desktop-blog")) {
        sortDropdownDesktop.classList.toggle("show");
      } else if (sortBtn.closest("#mobile-blog")) {
        sortDropdownMobile.classList.toggle("show");
      }
    });
  });

  document.addEventListener("click", function (event) {
    if (
      !sortDropdownDesktop.contains(event.target) &&
      !sortDropdownMobile.contains(event.target) &&
      !event.target.classList.contains("sortbtn")
    ) {
      sortDropdownDesktop.classList.remove("show");
      sortDropdownMobile.classList.remove("show");
    }
  });
}

function setupSortOptions() {
  const sortOptions = document.querySelectorAll("#SortDropdown-desktop .sort_options label");
  const sortOptionsMobile = document.querySelectorAll("#SortDropdown-mobile .sort_options label");
  const sortedContainers = document.querySelectorAll(".sorted-article");

  const defaultSortOption = sessionStorage.getItem("selected_Option") || "date-asc";
  sessionStorage.setItem("selected_Option", defaultSortOption);

  const defaultContainer = document.getElementById(`blog-sorted-by-${defaultSortOption}`);
  const defaultContainerMobile = document.getElementById(`blog-sorted-mobile-by-${defaultSortOption}`);
  if (defaultContainer) {
    defaultContainer.classList.remove("display-none");
  }
  if (defaultContainerMobile) {
    defaultContainerMobile.classList.remove("display-none");
  }

  sortOptions.forEach((option) => {
    option.addEventListener("click", function () {
      const selectedOption = option.getAttribute("value");
      sessionStorage.setItem("selected_Option", selectedOption);

      sortedContainers.forEach((container) => {
        container.classList.add("display-none");
      });

      const selectedContainer = document.getElementById(`blog-sorted-by-${selectedOption}`);
      if (selectedContainer) {
        selectedContainer.classList.remove("display-none");
      }
    });
  });

  sortOptionsMobile.forEach((option) => {
    option.addEventListener("click", function () {
      const selectedOption = option.getAttribute("value");
      sessionStorage.setItem("selected_Option", selectedOption);

      sortedContainers.forEach((container) => {
        container.classList.add("display-none");
      });

      const selectedContainerMobile = document.getElementById(`blog-sorted-mobile-by-${selectedOption}`);
      if (selectedContainerMobile) {
        selectedContainerMobile.classList.remove("display-none");
      }
    });
  });
}